exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".reset__text {\n  margin-bottom: 64px; }\n\n.reset__submit {\n  margin-top: 40px !important;\n  width: 100%; }\n\n.reset__error {\n  color: red;\n  text-align: center;\n  margin-top: 24px; }\n\n.reset__success {\n  color: green;\n  text-align: center;\n  margin-top: 24px; }\n\n.return__login__link {\n  margin: 16px 0 40px 0;\n  display: block;\n  text-align: center;\n  color: #ff8c8c;\n  text-decoration: underline; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./node_modules/sass-resources-loader/lib/loader.js??ref--1-oneOf-3-3!./src/components/Authentication/ResetForm/index.scss
// module id = 1042
// module chunks = 1